module.exports = __webpack_public_path__ + "media/images/icon__profile-dd278359ed148c1d443242b65a6737a0.png";